export const FUNC = 'function'
export const UNDEF = 'undefined'
export const REDUCER = 'reducer'

const base = '@@redux/'
export const ACTION_INIT = base + 'INIT'
export const ACTION_TEST = base + Math.random().toString(36)
